import { render, staticRenderFns } from "./ModifyPassword2.vue?vue&type=template&id=6dd61fcc&scoped=true&"
import script from "./ModifyPassword2.vue?vue&type=script&lang=js&"
export * from "./ModifyPassword2.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPassword2.vue?vue&type=style&index=0&id=6dd61fcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd61fcc",
  null
  
)

export default component.exports